import { AutomationActionType } from '@dadohr/shared/domainTypes/experience';
import { ErroDataType } from '@dadohr/shared/domainTypes/instance';
import type { ExperienceProblemData, InstanceErroWithData } from '../../InstanceProblems';

const WRITE_FAILED_TYPES = new Set<string>([ErroDataType.SALESFORCE_WRITE_FAILED, ErroDataType.UKG_WRITE_FAILED]);

/**
 * A sync-to-data-destination action is marked failed when any write it
 * queued is aborted. For Salesforce and UKG the worker also records its own
 * error for that write, stamped with the action's id, and that record carries
 * the specific cause and fix. Drop the action's generic failure when such a
 * record is open, so the problem shows once. Destinations without a worker
 * record (sheets, BambooHR, Workday, …) keep their action failure.
 */
export const withoutSyncFailuresCoveredByWriteErrors = (
  automationIssues: ExperienceProblemData[],
  instanceErrors: InstanceErroWithData[]
): ExperienceProblemData[] => {
  const coveredActionIds = new Set(
    instanceErrors
      .filter((e) => WRITE_FAILED_TYPES.has(e.type))
      .map((e) => (e as { actionTplId?: string }).actionTplId)
      .filter((id): id is string => !!id)
  );
  if (!coveredActionIds.size) return automationIssues;
  return automationIssues.filter(
    (issue) =>
      !(
        issue.type === 'AUTOMATION' &&
        issue.actionTpl.type === AutomationActionType.SYNC_TO_DATA_DESTINATION &&
        coveredActionIds.has(issue.actionTpl.id)
      )
  );
};
